function whatsappLink(mobile, message = "", pageUrl = "") {
  if (!mobile) return "#";

  let number = mobile?.replace(/\D/g, "");
  if (number?.startsWith("0")) number = "92" + number.slice(1);

  const finalMessage = `${message}${pageUrl ? `\n${pageUrl}` : ""}`;
  const text = encodeURIComponent(finalMessage);

  return `https://wa.me/${number}${text ? `?text=${text}` : ""}`;
}
export default whatsappLink;
